import { LazyLoadImage } from 'react-lazy-load-image-component';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import * as ST from './styled';

interface IProps {
    src: string,
    webpSrc: string,
    alt: string,
    height: number,
    width?: number,
    hasBorderRadius: boolean,
}

const SubscriptionImage = ({
    src,
    webpSrc,
    alt,
    height,
    width,

    hasBorderRadius,
} : IProps) => {
    return (
        <ST.Wrapper
            height={height}
            hasBorderRadius={hasBorderRadius}
        >
            <WebpImage urlWebp={webpSrc}>
                <LazyLoadImage
                    src={src}
                    alt={alt}
                    height={height}
                    width={width}
                    visibleByDefault={true}
                />
            </WebpImage>
        </ST.Wrapper>
    );
};

export default SubscriptionImage;
